import { useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Label,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const Estadisticas = (props) => {
  const { camara } = props;
  const [focusBar, setFocusBar] = useState(null);

  const data = [
    {
      name: "Aprobadas",
      cantidad: camara?.aprobadas,
      barColor: "var(--dark)",
      color: "var(--light)",
    },
    {
      name: "Nuevas",
      cantidad: camara?.nuevas,
      barColor: "var(--secondary)",
      color: "var(--dark)",
    },
    {
      name: "Descartadas",
      cantidad: camara?.descartadas,
      barColor: "var(--danger-hover)",
      color: "var(--dark)",
    },
    {
      name: "Enviadas",
      cantidad: camara?.enviadas,
      barColor: "var(--primary)",
      color: "var(--light)",
    },
    {
      name: "Nuestras",
      cantidad: camara?.infracciones_count,
      barColor: "var(--primary)",
      color: "var(--light)",
    },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const pl = payload[0]?.payload;

      return (
        <div
          className="custom-tooltip"
          style={{
            padding: "4px 8px",
            color: "white",
            backgroundColor: pl.barColor,
            border: "1px solid black",
            borderRadius: "4px",
          }}
        >
          <span className="fw-semibold">
            {pl.name}: {pl?.cantidad}
          </span>
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ maxWidth: "1500px", height: "300px", position: "relative" }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={150}
          height={40}
          overflow={"visible"}
          data={data}
          onMouseMove={(e) => setFocusBar(e?.activeTooltipIndex)}
          onMouseLeave={() => setFocusBar(null)}
          style={{ fontWeight: 600 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" interval="equidistantPreserveStart" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          {/* <Legend verticalAlign="top" /> */}
          <Bar dataKey="cantidad" label={{ position: "top" }}>
            {data.map((entry, i) => (
              <Cell
                name={entry?.name}
                key={`cell-${i}`}
                fill={entry?.barColor}
                opacity={focusBar === i ? 1 : 0.9}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Estadisticas;
